import {calendar} from '../js/data.json';
import analyticsEvent from './analytics-event';

let daysRoot;

let hrRoot;

let eventsRoot;

let daysButtons;
let curDay;
let initiated;



const createEvent = event => {
    if (event.content === 'hr') {
        return document.createElement('hr');

    } else if (Array.isArray(event.content)) {

        const root = document.createElement('div');
        root.classList.add('week__events__event');

        const time = event.time || '00:00';
        let content = '';

        event.content.forEach(item => {
            if (typeof item.header === 'string') {
                content += `<h3>${item.header}</h3>`;
            }

            if (typeof item.description === 'string') {
                content += `<p>${item.description}</p>`;
            }

            if (typeof item.addition === 'object') {
                if (typeof item.addition.header === 'string' && typeof item.addition.description === 'string') {
                    content += `<h4>${item.addition.header}<br><span>${item.addition.description}</span></h4>`;
                } else if (typeof item.addition.header === 'string') {
                    content += `<h4>${item.addition.header}</h4>`;
                }
            }
        });

        if (event.timeHidden) {
            root.innerHTML = `<div class="_content">${content}</div>`;
        } else {
            root.innerHTML = `<span class="_time">${time}</span><div class="_content">${content}</div>`;
        }

        return root;

    } else if (typeof event.content === 'object') {
        const root = document.createElement('div');
        root.classList.add('week__events__event');
        let content = '';

        if (typeof event.content.header === 'string' && typeof event.content.description === 'string') {
            content += `<h3>${event.content.header} <span>/ ${event.content.description}</span></h3>`;
        } else if (typeof event.content.header === 'string') {
            content += `<h3>${event.content.header}</h3>`;
        }

        if (typeof event.content.addition === 'object') {
            if (typeof event.content.addition.header === 'string' && typeof event.content.addition.description === 'string') {
                content += `<h4>${event.content.addition.header}<br><span>${event.content.addition.description}</span></h4>`;
            } else if (typeof event.content.addition.header === 'string') {
                content += `<h4>${event.content.addition.header}</h4>`;
            }
        }

        root.innerHTML = content;

        return root;
    }
};

const setEvents = (root, events, day = {}) => {
    resetEvents(root);

    const weekAdditional = document.getElementById('week-additional');
    if (day.day === 12) {
      weekAdditional.classList.add('week-additional__hidden')
    } else {
      weekAdditional.classList.remove('week-additional__hidden');
    }


    if (typeof day.columnCount !== 'undefined') {
        root.style.columnCount = day.columnCount;
    } else {
        root.style.columnCount = '';
    }

    events.forEach((eventData, index) => {
        const eventElement = createEvent(eventData);
        const timeOffset = 100 * index;

        eventElement.classList.add('a-hidden');

        setTimeout(() => {
            eventElement.classList.remove('a-hidden');
        }, timeOffset);


        root.appendChild(eventElement);
    });
};

const resetEvents = root => {
    while (root.firstChild) {
        root.removeChild(root.firstChild);
    }
};

const init = () => {
    if (initiated) return;

    const root = document.getElementById('week-root');

    if (!(root instanceof HTMLElement)) {
        return false;
    }

    const createButton = (day = 1, month = '01', title = 'Понедельник', timestamp) => {
        const button = document.createElement('button');
        button.classList.add('day-list__day');

        const daySpan = document.createElement('span');
        daySpan.classList.add('_day');
        daySpan.innerText = day;

        const monthSpan = document.createElement('span');
        monthSpan.classList.add('_month');
        monthSpan.innerText = month;

        const titleSpan = document.createElement('span');
        titleSpan.classList.add('_title');
        titleSpan.innerText = title;

        button.dataset.timestamp = timestamp;
        button.dataset.day = day;
        button.dataset.month = month;
        button.dataset.title = title;

        button.appendChild(daySpan);
        button.appendChild(monthSpan);
        button.appendChild(titleSpan);

        return button;
    };

    const setActiveButton = (button, buttons) => {
        let activeIndex;

        for (let i = 0; i < buttons.length; i++) {
            if (button === buttons[i]) {
                activeIndex = i;
                break;
            }
        }

        if (typeof activeIndex === 'number' && !buttons[activeIndex].classList.contains('active')) {
            buttons.forEach(btn => btn.classList.remove('active'));
            buttons[activeIndex].classList.add('active');

            root.dispatchEvent(new CustomEvent('daychange', {
                detail: {
                    activeButton: buttons[activeIndex]
                }
            }));
        }
    };

    const setButtons = (root, buttons) => {
        const activeIndex = 0;
        const date = new Date().getDate();

        buttons.forEach((button, index) => {

            if (index === activeIndex) {
                setActiveButton(button, buttons);
            } else if (date === parseInt(button.dataset.day)) {
                setActiveButton(button, buttons);
            }

            root.appendChild(button);

            const clickHandler = () => {
                setActiveButton(button, buttons);
            };

            button.addEventListener('click', clickHandler);
        });
    };

    const initTabs = () => {

        daysRoot = document.createElement('div');
        daysRoot.classList.add('week__day-list');

        hrRoot = document.createElement('div');
        hrRoot.classList.add('week__hr');

        eventsRoot = document.createElement('div');
        eventsRoot.classList.add('week__events');

        daysButtons = [];

        calendar.days.forEach(day => {
            daysButtons.push(createButton(day.day, day.month, day.title));
        });

        root.addEventListener('daychange', event => {
            const button = event.detail.activeButton;
            curDay = button.dataset.day;
            const day = calendar.days.find(item => item.day.toString() === button.dataset.day.toString());
            const events = calendar.events.filter(item => item.day.toString() === button.dataset.day.toString())
                .sort((a, b) => b.time < a.time ? 1 : -1);

            setEvents(eventsRoot, events, day);
            analyticsEvent('Calendar', 'open', `Day ${day.day}`);

            window.dispatchEvent(new Event('resize'));
        });
        root.appendChild(daysRoot);
        root.appendChild(hrRoot);
        root.appendChild(eventsRoot);

        setButtons(daysRoot, daysButtons);
    };


    initTabs();
    initiated = true;
};

const clear = () => {
    if (!initiated) return;
    resetEvents(eventsRoot);
};

const restore = () => {
    if (!curDay) init();

    const day = calendar.days.find(item => item.day.toString() === curDay.toString());
    const events = calendar.events.filter(item => item.day.toString() === curDay.toString())
        .sort((a, b) => b.time < a.time ? 1 : -1);

    setEvents(eventsRoot, events, day);
};

const week = {
    init: init,
    clear: clear,
    restore: restore
};

module.exports = week;



// WEBPACK FOOTER //
// ./js/week.js